module.exports.create = require('./lib/middleware/basic')
module.exports.createBasic = require('./lib/middleware/basic')
module.exports.createMapped = require('./lib/middleware/mapped')
module.exports.createMapFromPath = require('./lib/map-path')
